import { Table } from 'antd';
import CrmProductModalFull from './CrmProductModalFull.js';
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setProductDataAction} from "../store/actions/productActions";

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    },
    {

        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Barcode',
        dataIndex: 'barcode',
        key: 'barcode',
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        sorter: (a,b) => a.price - b.price
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
    },
    {
        title: 'Quantity pack',
        dataIndex: 'quantity_pack',
        key: 'quantity_pack',
    },
    {
        title: 'Unit',
        dataIndex: 'unit',
        key: 'unit',
    },
    {
        title: 'Created',
        dataIndex: 'created_at',
        key: 'created_at',
    },
];



function CrmProductListItem(products) {

    const dispatch = useDispatch();

    const [idProd, setIdProd] = useState(false);

    const dataSource = products.data;


    function getProductInfo(id) {
        dispatch(setProductDataAction(id))
        setIdProd(id);
    }



let productsData = [];
if (dataSource) {
    productsData = dataSource.map(item => ({...item, key:item.id}));
}

    return (
<>
    <CrmProductModalFull id={idProd} />



    <Table
        dataSource={productsData}
        columns={columns}
        onRow={(record, rowIndex) => {
            return {
                onClick: event => {
                    getProductInfo(record.id)
                }, // click row
                onDoubleClick: event => {

                }, // double click row
                onContextMenu: event => {}, // right button click row
                onMouseEnter: event => {}, // mouse enter row
                onMouseLeave: event => {}, // mouse leave row
            };
        }}
    />

</>
    );
}
export default CrmProductListItem;
